import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import React from 'react';
import { DispatchDto } from '../../../dtos/generated/DispatchDto';
import { formatDate } from '../../../util';

interface Props {
    dispatches: DispatchDto[];
}

const formatEquipment = (dispatch: DispatchDto): string => {
    const eq = dispatch.equipment;
    if (!eq) return '';
    return `${eq.equipmentType?.type ?? ''} #${eq.number ?? ''}`;
};

const formatTimeRange = (dispatch: DispatchDto): string => {
    return `${formatDate(dispatch.startDate, 'h:mm a')} – ${formatDate(dispatch.endDate, 'h:mm a')}`;
};

export const DispatchSummaryList: React.FC<Props> = ({ dispatches }) => {
    return (
        <Box>
            <Typography variant='subtitle2' gutterBottom>Assigned Dispatches</Typography>
            <Table size='small'>
                <TableHead>
                    <TableRow>
                        <TableCell>Driver / Broker</TableCell>
                        <TableCell>Time Range</TableCell>
                        <TableCell>Truck</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {dispatches.map((dispatch) => (
                        <TableRow key={dispatch.id}>
                            <TableCell>{dispatch.name ?? '—'}</TableCell>
                            <TableCell>{formatTimeRange(dispatch)}</TableCell>
                            <TableCell>{formatEquipment(dispatch)}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Box>
    );
};
